import { Button, Card, CardContent, Grid, Typography, } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { nbfCustomerByID, nbfInvoice } from "../../../api/restApi";
import DetailModal from "../../../components/modals/DeliverPaymentModal";
import InvoiceModal from "../../../components/modals/InvoiceModal";
import { customersData } from "../../../store/reducer/customersSlice";
import { generateBillForCustomer } from "../../../utils/helpers";
import { useAppSelector } from "../../../utils/hooks";
import { useSelector } from "react-redux";

const ComfirmOrder = ({ orderProduction, selectedDate, handleStatus }) => {
  const role = useSelector((state) => state.currentUser.role);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [orderCustomer, setOrderCustomer] = useState([]);
  const [openInvoice, setOpenInvoice] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { customers } = useAppSelector(customersData);
  const [orderByCustomer, setOrderByCustomer] = useState("");
  async function callData() {
    try {
      setOrderCustomer(
        orderProduction?.map((pro) => {
          return {
            ...pro,
            ...findCustomer(pro.customerId),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (orderProduction) {
      callData();
    }
  }, [orderProduction]);

  const findCustomer = (id) => {
    let cust = customers.find((el) => el.id?.toString() === id?.toString());
    let today = new Date();
    let date =
      today.getDate() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getFullYear();
    return {
      ...cust,
      label: cust.name_urdu,
      date: date,
      selectedDate: selectedDate,
    };
  };

  const today = new Date();
  today.setDate(today.getDate());
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, "0");
  const day = today.getDate().toString().padStart(2, "0");

  const handleViewClick = async (row) => {
    let invoiceView = await nbfInvoice(selectedDate, row.id);
    //console.log(invoiceView)
    let cust = await generateBillForCustomer({
      ...invoiceView,
      ...findCustomer(row.id),
    });

    setOrderByCustomer(cust);
    setOpenInvoice(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleDetailClick = async (row) => {
    const customerId = row.id;
    const singleCustomer= await nbfCustomerByID(customerId);
    if (singleCustomer.customer?.arrearAmount===undefined) {
      return Swal.fire({
        
        icon: "error",
        title: `"${row.name_urdu} has no account "`,
        text: "Please Create New Account!",
      });
  }
    else{
      setSelectedRowId(row.id);
      setIsModalOpen(true);
    }
  }


  return (
    <div>
    <Stack alignItems="center" spacing={1} marginTop="0rem">
    <Box sx={{ flexGrow: 0, padding: { xs: "1rem", md: "1rem" } }}>
      <Grid item xs={24} md={6}>
      <Card 
          alignItems='start'
                sx={{
                  width: "100%", 
                  marginTop: "0rem",
                  "@media (min-width: 300px)": {
                                width: 350, // Set the width to 100% for mobile view
                  },
                  "@media (min-width: 650px)": {
                                width: 650, // Set the width to 650px for screens wider than 650px
                  },
          }}
        >
    <CardContent>
        <Table
              marginRight="1rem"
              sx={{
                "@media (min-width: 315px)": {
                              width: 315, // Set the width to 100% for mobile view
                },
                "@media (min-width: 620px)": {
                              width: 620, // Set the width to 650px for screens wider than 650px
                },
        }}
            aria-label="simple table"
        >
            <TableHead style={{ backgroundColor: "#f5f5f5", height: "25px", align: 'start',width:'100%' }}>
              <TableRow sx={{ justifyContent:'start',width:'100%'}}>
              <TableCell>
                <Typography fontSize={"18px"} align="center">
                  ID
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  align="center"
                  fontSize={"18px"}
                >
                  CUSTOMER  
                </Typography>
              </TableCell>
              <TableCell>
                <Typography align="center" fontSize={"18px"} >
                  ACTION
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orderCustomer &&
              orderCustomer.map((row, index) => {
                return (
                  <>
                    <TableRow
                      key={index}
                    >
                    <TableCell align="start" style={{ width:"0%", fontSize: 15,}}>
                        {row.id.length > 5 ? row.id.slice(0, 5) : row.id}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          fontSize: "17px",
                          paddingLeft: "10px",
                          wordWrap: 'break-word', maxWidth: '100px',
                          fontFamily: "NotoNastaliqUrdu",
                          width:"50%"
                        }}
                      >
                        {row.name_urdu}{" "}
                      </TableCell>
                      <TableCell
                      align="center"
                        style={{
                          height: "25px",
                          fontSize: "14px",
                          width:"30%",
                          justifyContent:"end"

                        }}
                      >
                          <Button
                              style={{justifyContent: 'center', width: '4rem',marginLeft:'1rem'}}
                              variant="outlined"
                              onClick={() => handleViewClick(row)}
                            >
                              View
                            </Button>
                            {role !=="cs" &&(
                            <Button
                              style={{justifyContent: 'center', width: '4rem',marginLeft:'1rem' }}
                              variant="outlined"
                              onClick={() => handleDetailClick(row)}
                            >
                              Update
                            </Button>
                            )}
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
          </TableBody>
        </Table>
        </CardContent>
        </Card>
      </Grid>
      </Box>
      </Stack>
      {orderByCustomer && (
        <InvoiceModal
          openInvoice={openInvoice}
          orderByCustomer={orderByCustomer}
          setOpenInvoice={setOpenInvoice}
        />
      )}
      <DetailModal
        date={selectedDate}
        customerId={selectedRowId}
        detailOpen={isModalOpen}
        handleClose={closeModal}
        handleStatus={handleStatus}
        orderByCustomer={orderByCustomer}
      />
    </div>
  );
};

export default ComfirmOrder;
